import styled, { css } from 'styled-components'
import {
  FontProps,
  fontCss,
  lineHeightCss,
  mobileFontCss,
  mobileLineHeightCss,
} from '../../../../utils/styleUtilsNew'

type PriceDescriptionUiProps = {
  lineHeight: number
  mobileLineHeight?: number
} & FontProps
const PricePlanDescriptionUi = styled.div<PriceDescriptionUiProps>`
  color: ${p => p.color};
  ${fontCss}
  ${lineHeightCss}
  ${p => p.theme.phone} {
    ${mobileFontCss}
    ${mobileLineHeightCss}
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileFontCss}
      ${mobileLineHeightCss}
    `}
`

export default PricePlanDescriptionUi
